import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export const adminService = {
  async checkCurrentUserRole(): Promise<string | null> {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (!user) {
        console.error('No user is signed in');
        return null;
      }

      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        console.error('User document does not exist');
        return null;
      }

      return userDoc.data().role || null;
    } catch (error) {
      console.error('Error checking user role:', error);
      return null;
    }
  }
}; 